export default "__VITE_ASSET__C7ICQqZ0__"